export default __webpack_public_path__ + "static/media/BGImage.b2d4dfee.jpg";